import { render, staticRenderFns } from "./OsBusinessErrorDialog.vue?vue&type=template&id=073ea788&scoped=true"
import script from "./OsBusinessErrorDialog.vue?vue&type=script&lang=ts"
export * from "./OsBusinessErrorDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073ea788",
  null
  
)

export default component.exports